import React, { useState, useEffect } from 'react';
import {
  Grid,
  IconButton,
  SvgIcon,
  Box,
  Divider,
  Tooltip,
  TextField,
  Card,
  CardHeader,
  MenuItem,
} from '@material-ui/core';
import ClearAllIcon from '@material-ui/icons/ClearAll';
import { InputModal, FilterChip } from '@shared/components';
import { handleChipDelete } from '../../../utils/filterHelpers';
import useTheme from '../../../hooks/useTheme';

const Filter = ({
  currentValues,
  visible,
  setVisible,
  handleFilterChange,
  getLabelText,
  getChipValue,
  setFilters,
  setPage,
}) => {
  const theme = useTheme();

  const [filterValues, setFilterValues] = useState({});
  const handleClose = () => setVisible(false);

  const onSubmit = () => {
    handleFilterChange(filterValues, setFilters, setPage);
    setVisible(false);
  };

  useEffect(() => setFilterValues(currentValues), [currentValues]);
  return (
    <InputModal
      filterTitle="Pretraga vrsta knjiga"
      visible={visible}
      handleClose={handleClose}
      onSubmit={onSubmit}
      modalWidth="45%"
      theme={theme}
      filter
    >
      <Box padding={`${theme.spacing(5)}px`}>
        <Box p={2} display="flex" alignItems="center" flexWrap="wrap">
          {Object.keys(filterValues).map(
            (chip) =>
              filterValues[chip] !== undefined && (
                <FilterChip
                  color="primary"
                  variant="outlined"
                  key={chip}
                  label={`${getLabelText(chip)}: ${getChipValue(chip, filterValues)}`}
                  onDelete={() => handleChipDelete(chip, setFilterValues)}
                />
              ),
          )}
        </Box>
        <Box>
          <Card elevation={4}>
            <CardHeader
              titleTypographyProps={{ variant: 'subtitle2' }}
              title="Podaci o vrsti knjige"
              action={
                <Tooltip enterDelay={300} placement="top-end" arrow title="Ukloni filtere">
                  <IconButton
                    onClick={() => {
                      setFilterValues({});
                    }}
                  >
                    <SvgIcon fontSize="small">
                      <ClearAllIcon />
                    </SvgIcon>
                  </IconButton>
                </Tooltip>
              }
            />
            <Divider />
            <Box elevation={5} style={{ padding: `${theme.spacing(5)}px` }}>
              <Grid container direction="row" spacing={5} style={{ maxHeight: 500 }}>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    label="Šifra"
                    name="code"
                    placeholder="Unesite šifru za pretragu"
                    value={filterValues.code || ''}
                    onChange={({ target: { value } }) =>
                      setFilterValues((prevState) => ({
                        ...prevState,
                        code: value?.length === 0 ? undefined : value,
                      }))
                    }
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    label="Naziv"
                    name="name"
                    placeholder="Unesite naziv za pretragu"
                    value={filterValues.name || ''}
                    onChange={({ target: { value } }) =>
                      setFilterValues((prevState) => ({
                        ...prevState,
                        name: value?.length === 0 ? undefined : value,
                      }))
                    }
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    label="Važi"
                    select
                    name="isValid"
                    value={filterValues.isValid || ''}
                    variant="standard"
                    onChange={({ target: { value } }) =>
                      setFilterValues((prevState) => ({
                        ...prevState,
                        isValid: value || value?.length > 0 ? value : undefined,
                      }))
                    }
                  >
                    <MenuItem value="D">DA</MenuItem>
                    <MenuItem value="N">NE</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    label="Dozvoljen vlastiti predmet"
                    select
                    name="ownSubjectAllowed"
                    value={filterValues.ownSubjectAllowed || ''}
                    variant="standard"
                    onChange={({ target: { value } }) =>
                      setFilterValues((prevState) => ({
                        ...prevState,
                        ownSubjectAllowed: value || value?.length > 0 ? value : undefined,
                      }))
                    }
                  >
                    <MenuItem value="D">DA</MenuItem>
                    <MenuItem value="N">NE</MenuItem>
                  </TextField>
                </Grid>
              </Grid>
            </Box>
          </Card>
        </Box>
      </Box>
    </InputModal>
  );
};

export default Filter;
